import { Components, Theme, buttonClasses } from '@mui/material';
import { Corners } from '../corners/tokens';

export const MuiButtonGroup: Components<Theme>['MuiButtonGroup'] = {
  defaultProps: {
    disableFocusRipple: true,
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      boxShadow: 'none',
      borderRadius: Corners.large,
    },
    grouped: {
      minWidth: 32,
    },
    firstButton: {
      border: 0,
      marginRight: 1,
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
      },
    },
    middleButton: {
      border: 0,
      marginRight: 1,
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
      },
    },
    lastButton: {
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
      },
    },
  },
};
